import { Pipe, PipeTransform } from '@angular/core';
import { Message } from 'app/core/models/message';

@Pipe({ name: 'filterMessageWithFiles', standalone: true })
export class FilterMessagesWithFilesPipe implements PipeTransform {
  
  transform(messages: Message[] | null): Message[] {
    if (!messages) {
      return [];
    }
    return messages.filter(m => m.hasFiles);
  }
}
